<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        class="project-contract-edit-dialog ah-detail-dialog"
        top="6vh"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="onCancel"
        @open="onOpen"
        @closed="onClosed"
    >
        <template slot="title">
            <div v-if="contract">編輯文件</div>
            <div v-else>新增文件</div>
        </template>
        <div class="layout">
            <div class="form-block">
                <div v-if="!!project.sno" class="project-info-block">
                    <div style="margin: 15px 0 0 0">
                        <div style="font-size: 10.5pt; margin-bottom: 5px; color: #574fba">
                            <div>{{ project.pjcaT_NAM }}</div>
                        </div>
                        <div style="font-size: 15pt; font-weight: bold; margin-top: 5px">
                            <div>{{ project.nam }}</div>
                        </div>
                    </div>
                </div>
                <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="150px">
                    <el-form-item prop="attachment">
                        <template v-slot:label>
                            檔案<span style="font-size: 12px; color: #aaa; margin-left: 10px">(檔案大小上限：25MB)</span>
                        </template>
                        <UploadSingleFileInput v-model="form.attachment" />
                    </el-form-item>
                    <el-form-item prop="attachmenType" label="類型">
                        <el-select v-model="form.attachmenType" placeholder="請選擇">
                            <el-option v-for="item in contractTypeList" :label="item.label" :key="`contract-type-${item.value}`" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="備註">
                        <el-input v-model="form.note" maxlength="200" show-word-limit />
                    </el-form-item>
                    <el-form-item prop="" label="">
                        <el-alert type="warning" :closable="false" style="line-height: 120%; margin-top: -10px; width: fit-content">
                            建議將重要檔案先自行加密在上傳。
                        </el-alert>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!-- Footer 功能按鈕 -->
        <div class="detail-row footer">
            <div style="text-align: center">
                <el-button :loading="isLoading" @click="onCancel">取消</el-button>
                <el-button v-if="!!contract" :loading="isLoading" type="primary" class="primary-action" @click="onSubmit()">
                    儲存
                </el-button>
                <el-button v-else :loading="isLoading" type="primary" class="primary-action" @click="onSubmit(true)">
                    新增
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import UploadSingleFileInput from '@/components/ui/UploadSingleFileInput.vue';
import { projectContractTypeOptions } from '@/assets/commonData/options';

export default {
    props: {
        visible: Boolean,
        value: {
            type: Array,
            default: () => [],
        },
        contract: {
            type: Object,
            default: () => {},
        },
        project: {
            type: Object,
            default: () => {},
        },
        sno: {
            type: Number,
            default: null,
        },
    },
    components: { UploadSingleFileInput },
    data() {
        return {
            contractTypeList: projectContractTypeOptions,
            isLoading: false,
            form: {
                attachment: null,
                attachmenType: null,
                note: null,
            },
            rules: {
                attachmenType: [
                    {
                        required: true,
                        message: '此欄位為必填',
                    },
                ],
            },
        };
    },
    methods: {
        onOpen() {
            console.log(this.sno);
            if (this.contract) this.form = { ...this.contract };
            this.form.updateUser = this.$store.getters['account/userName'];
            this.form.updateDate = Number(moment().format('x'));
        },
        onClosed() {
            console.log('hi');
            this.form = {
                attachment: null,
                attachmenType: null,
                note: null,
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        onCancel() {
            this.onClose(false);
        },
        onClose(refresh) {
            this.$emit('close', refresh);
        },
        onSubmit(add) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (!this.form.attachment) {
                        this.$message({
                            showClose: true,
                            message: '請至少上傳圖片或文件',
                            type: 'error',
                        });
                        return false;
                    }
                    try {
                        this.isLoading = true;
                        if (add) await this.onAdd();
                        else await this.onUpdate();
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isLoading = false;
                    }
                    return false;
                }
                return true;
            });
        },
        async onAdd() {
            if (!this.sno) {
                this.$emit('input', [...this.value, this.form]);
                this.onClose();
                return;
            }
            await this.$api({
                url: '/ProjectManagementPage/NewContractFiles',
                method: 'POST',
                data: { projectSno: this.project.sno, ...this.form },
            });

            this.$message({
                showClose: true,
                message: '已新增文件',
                type: 'success',
            });

            this.onClose(true);
        },
        async onUpdate() {
            if (!this.sno) {
                const FOUND = _.findIndex(this.value, this.contract);
                const INPUT = [...this.value];
                console.log(FOUND);
                INPUT.splice(FOUND, 1, this.form);
                this.$emit('input', INPUT);
                this.onClose();
                return;
            }
            await this.$api({
                url: '/ProjectManagementPage/UpdateContractFile',
                method: 'POST',
                data: { sno: this.contract.sno, projectSno: this.project.sno, ...this.form },
            });

            this.$message({
                showClose: true,
                message: '已更新文件',
                type: 'success',
            });

            this.onClose(true);
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-used-msg {
    line-height: 2;
    margin-top: 5px;
    font-size: 9pt;
    color: red;
}
</style>
<style lang="scss">
.project-contract-edit-dialog.ah-detail-dialog {
    padding: 0 10px;

    .el-dialog {
        max-width: 600px;
        min-height: 300px;
    }

    &.file {
        .el-dialog {
            max-width: 830px;
        }
    }

    .layout {
        display: block;
        width: 100%;

        @media (min-width: 992px) {
            display: table;
        }

        .file-block {
            display: block;
            height: 100%;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }
        }

        .image-block {
            display: block;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }

            .el-image {
                img {
                    object-fit: contain;
                    max-height: 500px;
                }
            }
        }

        .form-block {
            display: block;
            padding: 25px;

            @media (max-width: 720px) {
                width: 100%;
            }

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
            }
        }
        .project-info-block {
            margin-bottom: 20px;
        }
    }
    .el-input input {
        padding-right: 50px;
    }
}
</style>
